if (!customElements.get('newsletter-modal')) {
  customElements.define('newsletter-modal', class extends ModalElement {
    constructor() {
      super();
      if (window.location.pathname === '/challenge' || !theme.cookiesEnabled()) return;
      this.init();
    }
    get shouldLock() { return true; }
    get delay() { return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5; }
    get sessionKey() { return 'noonaway:newsletter-shown:v1'; }
    get submited() { return this.querySelector('.alert') !== null; }
    hasShown() {
      if (window.noonawayNewsletterShown) return true;
      try { return window.sessionStorage.getItem(this.sessionKey) === 'true'; }
      catch (error) {
        return document.cookie.split(';').some(part => part.trim() === 'noonaway_newsletter_session=true');
      }
    }
    rememberShown() {
      window.noonawayNewsletterShown = true;
      try { window.sessionStorage.setItem(this.sessionKey, 'true'); }
      catch (error) { document.cookie = 'noonaway_newsletter_session=true; path=/; SameSite=Lax; Secure'; }
    }
    init() {
      if (this.initialized) return;
      this.initialized = true;
      if (this.submited) { this.load(1, true); return; }
      if (!this.hasShown()) this.load(this.delay);
    }
    load(delay, formResult = false) {
      if (Shopify.designMode) return;
      setTimeout(() => {
        if (!formResult && this.hasShown()) return;
        this.rememberShown();
        this.show();
      }, delay * 1000);
    }
    afterShow() {
      super.afterShow();
      this.rememberShown();
      this.classList.add('show-image');
    }
    afterHide() {
      super.afterHide();
      this.classList.remove('show-image');
    }
  });
}
